import { render } from "./chevron-up-down.vue?vue&type=template&id=6ace408a"
import script from "./chevron-up-down.vue?vue&type=script&lang=js"
export * from "./chevron-up-down.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__